import { useRef, useEffect } from 'react';

function useTimeout(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function executeCallback() {
      savedCallback.current();
    }

    if (delay !== null) {
      const timeoutId = setTimeout(executeCallback, delay);
      return () => clearTimeout(timeoutId);
    }
  }, [delay]);
}

export default useTimeout;
